import React from "react";
// import BannerSectionStyle7 from "../Section/BannerSection/BannerSectionStyle7";
import Section from "../Section";
// import AppointmentSection from "../Section/AppointmentSection";
// import BreadcrumbStyle2 from "../Breadcrumb/BreadcrumbStyle2";
// import AboutSectionStyle2 from "../Section/AboutSection/AboutSectionStyle2";
// import FeaturesSectionStyle3 from "../Section/FeaturesSection/FeaturesSectionStyle3";
import TeamSectionStyle3 from "../Section/TeamSection/TeamSectionStyle3";
import { pageTitle } from "../../helpers/PageTitle";
// import Breadcrumb from "../Breadcrumb";
// import WorkingProcess from "../Section/WorkingProcess";
import BannerSectionStyle2 from "../Section/BannerSection/BannerSectionStyle2";
import FaqSectionStyle3 from "../Section/FaqSection/FaqSectionStyle3";
import DoctorDetailsSection from "../Section/DoctorDetailsSection";
import Spacing from "../Spacing";
import DepartmentSectionStyle3 from "../Section/DepartmentSection/DepartmentSectionStyle3";
import TeamSectionStyle2 from "../Section/TeamSection/TeamSectionStyle2";
import { Helmet } from "react-helmet";

export default function MercuryS1SurgicalSaw() {
  pageTitle("MercuryMini Details");
  return (
    <>
      <Helmet>
        <title>Sternum Saw S1: Leading Manufacturer and Exporter in India, Mercury HC

        </title>

        <meta name="Keyword" content="Sternum Saw Manufacturers & Suppliers in India,
Sternum Saw Electric Exporter from India,
Sternum Saw - Sternal Saw Latest Price,
Buy Electrical Sternum Saw in bulk at wholesale price,
Cardiac Surgery Equipments - Battery Operated Sternum Saw,
Sternum Saw (for trauma operation),
Sternum Saw at Best Price from Manufacturers,
Top Sternum Saw Manufacturers in India,
Best Sternum Saw Manufacturers & Suppliers in India," />
        <meta name="description" content="Discover Mercury HC, India's leading manufacturer and exporter of sternum saws. Our saws offer exceptional control with a clear line of sight, lightweight design, and quick-release blades. ETO sterilizable and compatible with S1 electro-mechanical systems, ensuring top-quality surgical solutions." />
        {/* Google Tag (gtag.js) */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-MGF4V7P4YB"></script>
        <script>
          {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-MGF4V7P4YB');
      `}
        </script>

      </Helmet>
      <Section topMd={170} topLg={145} topXl={90} bottomLg={90}>
        <div className="cs_doctor_details">
          <div className="cs_doctor_details_bg cs_bg_filed" />
          <Spacing md="85" />
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="cs_single_doctor overflow-hidden cs_radius_20 p-5">
                  <img
                    src="/images/doctors/Mercury-S1-Sternum-Saw.jpg"
                    alt="Doctor"
                    className="w-100 cs_radius_20 "
                  />
                  <h3
                    className="cs_white_color cs_accent_bg mb-0 text-center cs_semibold cs_fs_24"
                    style={{
                      padding: "14px 15px",
                    }}
                  >
                    Mercury-S1-Sternum-Saw
                  </h3>
                </div>
              </div>
              <div className="col-lg-6   position-relative">
                <Spacing md="55" />
                <h1
                  className="cs_fs_120 mb-0 cs_semibold"
                  style={{
                    fontSize: "45px",
                    color: "#3f48cc",
                  }}
                >
                  {" "}
                  Mercury-S1-Sternum-Saw{" "}
                </h1>

                <Spacing md="32" />
                <p className="mb-0 cs_heading_color">
                  {" "}
                  Efficient heater with touch control, 5-liter capacity, and
                  wide temperature range.{" "}
                </p>

                <Spacing md="32" />

                <ul>
                  <li>
                    <strong
                      style={{
                        color: "black",
                      }}
                    >
                      {" "}
                      Cutting Edge Technology with Clear Line of Sight{" "}
                    </strong>
                  </li>
                  <li
                    style={{
                      color: "black",
                    }}
                  >
                    <strong>
                      {" "}
                      Lightweight Design Provides Exceptional Control{" "}
                    </strong>
                  </li>
                  <li
                    style={{
                      color: "black",
                    }}
                  >
                    <strong> Sharp Single-Use Blade </strong>
                  </li>
                  <li
                    style={{
                      color: "black",
                    }}
                  >
                    <strong>
                      {" "}
                      Reversible Blade Design Allows Cutting in Both Directions{" "}
                    </strong>
                  </li>
                  <li
                    style={{
                      color: "black",
                    }}
                  >
                    <strong>
                      {" "}
                      Tapered blade protector deflects underlying tissue from
                      blade contact{" "}
                    </strong>
                  </li>
                  <li
                    style={{
                      color: "black",
                    }}
                  >
                    <strong>
                      {" "}
                      Enhanced Convenience with Quick-release blades{" "}
                    </strong>
                  </li>
                  <li
                    style={{
                      color: "black",
                    }}
                  >
                    <strong>
                      {" "}
                      Autoclavable or ETO sterilized to ensure quick turnaround
                      time{" "}
                    </strong>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Section>

      <Section topMd={170} topLg={145} topXl={90} bottomLg={90}>
        <div className="container">
          <div className="img-details-container">
            {/* Left Section: Features and Product Images */}
            <div className="left-section">
              {/* Title */}
              {/* <h2>{item.tittle}</h2> */}

              {/* Features List */}
              <div
                className="featureList"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <div className="listdata">
                  <h3 className="underline">Components & Accessories:</h3>
                  <ul>
                    <li>
                      <strong> M04-01 Sternum Saw S1 Handpiece</strong>
                    </li>
                    <li>
                      <strong> M04-02 Variable Speed Footswitch</strong>
                    </li>
                    <li>
                      <strong>
                        {" "}
                        M04-03 Flexible Drive Cable (Autoclavable){" "}
                      </strong>
                    </li>
                    <li>
                      <strong> Power Unit (Motor) </strong>
                    </li>
                    <li>
                      <strong> Blade Protector </strong>
                    </li>
                    <li>
                      <strong> Non Sterile Blade </strong>
                    </li>
                  </ul>
                </div>
                <div className="iamgeboxed">
                  <img src="/images/detailspageimages/30.png" alt="Doctor" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>

      <Section>
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="cs_single_doctor overflow-hidden cs_radius_20 p-5">
                <img
                  src="/images/detailspageimages/10.png"
                  alt="Doctor"
                  className="w-100 cs_radius_20 "
                />
                <h3
                  className="cs_white_color cs_accent_bg mb-0 text-center cs_semibold cs_fs_24"
                  style={{
                    padding: "0px 15px",
                  }}
                >
                  M04-01 <br></br>
                  Sternum Saw S1
                </h3>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="cs_single_doctor overflow-hidden cs_radius_20 p-5">
                <img
                  src="/images/detailspageimages/11.png"
                  alt=""
                  className="w-100 cs_radius_20 "
                />
                <h3
                  className="cs_white_color cs_accent_bg mb-0 text-center cs_semibold cs_fs_24"
                  style={{
                    padding: "0px 15px",
                  }}
                >
                  M04-05 <br></br>
                  Blade Protector
                </h3>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="cs_single_doctor overflow-hidden cs_radius_20 p-5">
                <img
                  src="/images/detailspageimages/12.png"
                  alt="Doctor"
                  className="w-100 cs_radius_20 "
                />
                <h3
                  className="cs_white_color cs_accent_bg mb-0 text-center cs_semibold cs_fs_24"
                  style={{
                    padding: "0px 15px",
                  }}
                >
                  M04-04 <br></br>
                  Power Unit (Motor)
                </h3>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="cs_single_doctor overflow-hidden cs_radius_20 p-5">
                <img
                  src="/images/detailspageimages/13.png"
                  alt="Doctor"
                  className="w-100 cs_radius_20 "
                />
                <h3
                  className="cs_white_color cs_accent_bg mb-0 text-center cs_semibold cs_fs_24"
                  style={{
                    padding: "0px 15px",
                  }}
                >
                  M04-06 <br></br>
                  Non Sterile Blade
                </h3>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="cs_single_doctor overflow-hidden cs_radius_20 p-5">
                <img
                  src="/images/detailspageimages/14.png"
                  alt="Doctor"
                  className="w-100 cs_radius_20 "
                />
                <h3
                  className="cs_white_color cs_accent_bg mb-0 text-center cs_semibold cs_fs_24"
                  style={{
                    padding: "0px 15px",
                  }}
                >
                  M04-03 <br></br>
                  Flexible Drive Cable
                </h3>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="cs_single_doctor overflow-hidden cs_radius_20 p-5">
                <img
                  src="/images/detailspageimages/15.png"
                  alt="Doctor"
                  className="w-100 cs_radius_20 "
                />
                <h3
                  className="cs_white_color cs_accent_bg mb-0 text-center cs_semibold cs_fs_24"
                  style={{
                    padding: "0px 15px",
                  }}
                >
                  M04-02 <br></br>
                  Sternum Saw S1
                </h3>
              </div>
            </div>
          </div>
        </div>
      </Section>
      <Spacing md="60" />
    </>
  );
}
